import { wrapWithProvider } from '~components/wrapWithProvider';
import { sharedRoot } from './gatsby-shared';

import type { GatsbyBrowser } from 'gatsby';
import type { PageContext } from '~components/wrapWithProvider';

require('~styles/global.css');

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => sharedRoot(element);

export const wrapPageElement: GatsbyBrowser<unknown, PageContext>['wrapPageElement'] = wrapWithProvider;

let nextRoute: string;

export const onPreRouteUpdate: GatsbyBrowser['onPreRouteUpdate'] = ({ location }) => {
  nextRoute = location.pathname;
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  updateCanonicalURL(location);

  if (process.env.NODE_ENV === `production`) {
    setTimeout(() => {
      window?.dataLayer?.push({ event: 'route-change' });
    }, 50);
  }
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({ pathname }) => {
  history.scrollRestoration = pathname.includes('over-ons') ? 'manual' : 'auto';
  return false;
};

export const disableCorePrefetching: GatsbyBrowser['disableCorePrefetching'] = () => true;

window.addEventListener('unhandledrejection', ({ reason }) => {
  if (/loading chunk \d* failed./i.test(reason)) {
    if (nextRoute) window.location.pathname = nextRoute;
  }
});

const updateCanonicalURL = (location: Location) => {
  const element = document.querySelector(`link[rel='canonical']`);

  if (!element) return;

  const existingValue = element.getAttribute(`href`);
  const baseProtocol = element.getAttribute(`data-baseProtocol`);
  const baseHost = element.getAttribute(`data-baseHost`);

  if (existingValue && baseProtocol && baseHost) {
    const value = `${baseProtocol}//${baseHost}${location.pathname}${location.hash}`;
    element.setAttribute(`href`, value);
  }
};
